import MessageBox from './MessageBox'

export default MessageBox
// eslint-disable-next-line import/export
export * from './MessageBox'
